import React from 'react';
import { Button, ProgressBar, Spinner } from 'src/components/atoms';
import {
  ProgressCardContainer,
  ProgressCardContent,
  ProgressCardDescription,
  ProgressCardSpinnerContainer,
  ProgressCardTitle,
  ProgressInfo,
} from './ProgressCard.styles';

interface ProgressCardProps {
  title: string;
  description: string;
  percentage: number;
  progressInfo: React.ReactNode;
  onStopProgress?: (() => void) | null;
  stopProgressLabel?: string;
}

export const ProgressCard: React.FC<ProgressCardProps> = ({
  title,
  description,
  percentage,
  progressInfo,
  onStopProgress,
  stopProgressLabel = 'Cancel',
}) => {
  return (
    <ProgressCardContainer data-testid="progress-card-container">
      <ProgressCardSpinnerContainer data-testid="progress-card-spinner">
        <Spinner variant="secondary" size="large" />
      </ProgressCardSpinnerContainer>
      <ProgressCardContent data-testid="progress-card-content">
        <ProgressCardTitle data-testid="progress-card-title">
          {title}
          {onStopProgress && (
            <Button
              data-testid="progress-card-stop-button"
              variant="secondary"
              size="small"
              onClick={onStopProgress}
              disabled={percentage === 100}
            >
              {stopProgressLabel}
            </Button>
          )}
        </ProgressCardTitle>
        <ProgressCardDescription data-testid="progress-card-description">
          {description}
        </ProgressCardDescription>
        <ProgressBar percentage={percentage} barWidth={'100%'} />
        <ProgressInfo data-testid="progress-card-info">
          {progressInfo}
        </ProgressInfo>
      </ProgressCardContent>
    </ProgressCardContainer>
  );
};
